// Bible Buds Mascot Characters
export const MASCOTS = {
  lamb: {
    name: "Woolly",
    image: "https://static.prod-images.emergentagent.com/jobs/1f9e7365-fb89-487b-ba77-2873138d0c06/images/e161a7473b7b7af947acd7cf8caa44991462817257af35b9d6a3f323f722efab.png",
    greeting: "Hi friend! Ready to learn about God's love?",
    encouragement: "You're doing amazing! Keep going!",
    celebration: "Yay! You did it! God is so proud of you!"
  },
  lion: {
    name: "Bravey",
    image: "https://static.prod-images.emergentagent.com/jobs/1f9e7365-fb89-487b-ba77-2873138d0c06/images/8cbc848c9d5074b208fbfa632230b8dcad8533f11349813bf3b20734b1e33690.png",
    greeting: "Be strong and courageous! Let's learn together!",
    encouragement: "You've got this! Be brave like Daniel!",
    celebration: "ROAR! What a champion for God!"
  },
  dove: {
    name: "Peaceful",
    image: "https://static.prod-images.emergentagent.com/jobs/1f9e7365-fb89-487b-ba77-2873138d0c06/images/6d0098d554917d6c1ed2e0572dbb8cc6c89027cea08e13b842d48c17a937aeb4.png",
    greeting: "Peace be with you! Let's discover God's word!",
    encouragement: "Take your time, you're doing wonderfully!",
    celebration: "Beautiful! May God's peace fill your heart!"
  },
  owl: {
    name: "Wisely",
    image: "https://static.prod-images.emergentagent.com/jobs/04e943a7-d13c-40a4-9287-aab924d8e268/images/9ad701fbdac1f068b692e23938f0c2923e9e42dbb3084359307f091cd4fed031.png",
    greeting: "Hello wise learner! Let's discover wisdom today!",
    encouragement: "Great thinking! You're growing wiser every day!",
    celebration: "Hoo-ray! You're so wise! God loves that!"
  },
  bunny: {
    name: "Hoppy",
    image: "https://static.prod-images.emergentagent.com/jobs/04e943a7-d13c-40a4-9287-aab924d8e268/images/1184116042de58d3211f680243f68a678aeb582a90c3d7dc4862ad4da7b599d1.png",
    greeting: "Hop on in! Let's learn about Jesus together!",
    encouragement: "Keep hopping along! You're doing great!",
    celebration: "Hippity-hop hooray! You did it!"
  },
  butterfly: {
    name: "Flutter",
    image: "https://static.prod-images.emergentagent.com/jobs/04e943a7-d13c-40a4-9287-aab924d8e268/images/99f57fed1b9b47081ffd24440979c6c6cebf4bb3d6903e3832b82d785ea9ebe6.png",
    greeting: "Spread your wings! Let's fly through God's word!",
    encouragement: "You're transforming into something beautiful!",
    celebration: "You're shining bright like a butterfly! Amazing!"
  },
  fish: {
    name: "Finley",
    image: "https://static.prod-images.emergentagent.com/jobs/04e943a7-d13c-40a4-9287-aab924d8e268/images/819e815db304e3e4aeec5ec005b4d9bb50e1b315355bdcce9d8ced3d2e33c3b0.png",
    greeting: "Dive in! Let's swim through today's story!",
    encouragement: "Keep swimming! You're doing swimmingly!",
    celebration: "Splash-tastic! You're a star of the sea!"
  }
};

export function MascotBubble({ mascot = "lamb", type = "greeting", className = "" }) {
  const m = MASCOTS[mascot] || MASCOTS.lamb;
  const message = m[type] || m.greeting;
  
  return (
    <div className={`flex items-end gap-3 ${className}`}>
      <img 
        src={m.image} 
        alt={m.name} 
        className="w-16 h-16 object-contain drop-shadow-lg animate-bounce"
        style={{ animationDuration: "2s" }}
      />
      <div className="relative bg-white rounded-2xl rounded-bl-none px-4 py-3 shadow-md max-w-xs">
        <p className="text-sm font-semibold text-[#073B4C]" style={{ fontFamily: "Quicksand, sans-serif" }}>
          {message}
        </p>
        <p className="text-xs text-gray-400 font-bold mt-1">— {m.name}</p>
      </div>
    </div>
  );
}

export function MascotImage({ mascot = "lamb", size = 64, className = "" }) {
  const m = MASCOTS[mascot] || MASCOTS.lamb;
  return (
    <img 
      src={m.image} 
      alt={m.name} 
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function RandomMascotBubble({ type = "greeting", className = "" }) {
  const mascots = Object.keys(MASCOTS);
  const randomMascot = mascots[Math.floor(Math.random() * mascots.length)];
  return <MascotBubble mascot={randomMascot} type={type} className={className} />;
}
